import { makeStyles } from "@material-ui/core";

const useGenderDropdownStyles = makeStyles(() => ({
  fontFamilyAlmarai: {
    fontFamily: "Almarai-semi !important",
  },
  fontFamilyEina: {
    fontFamily: "Eina-semi !important",
  },
  genderFormControl: {
    margin: 0,
  },
  genderSelect: {
    paddingTop: "0px !important",
    paddingBottom: "0px !important",
    paddingLeft: "0px !important",
    paddingRight: "24px !important",
    minHeight: "unset",
    display: "flex",
    alignItems: "center",
  },
  genderSelectValue: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  genderPlaceholder: {
    color: "gray",
  },
}));

export default useGenderDropdownStyles;